// ============================================================================
// CREATESPRINTMODAL.JS - Modal de creación de sprint (activo o de planificación)
// ============================================================================
// Estado del formulario AISLADO en este componente: al escribir NO se re-renderiza
// ActiveSprintPanel (que lleva las tablas animadas de Framer Motion) → sin lag.
// El padre solo recibe onSubmit(sprintData) y hace la llamada al store + toasts.
// ============================================================================

import React, { useEffect, useState } from 'react';
import { X, Save } from 'lucide-react';

function CreateSprintModal({ mode = 'activo', submitting = false, onClose, onSubmit }) {
  const isPlanning = mode === 'planificacion';

  const [nombre, setNombre] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');

  // Cierre con Escape (el foco inicial ya lo da autoFocus en el nombre).
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !submitting) onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [submitting, onClose]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nombre.trim()) return;
    onSubmit({
      nombre: nombre.trim(),
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin,
    });
  };

  return (
    <div className="sprint-modal-overlay u-sheet-overlay" onClick={onClose}>
      <div
        className="sprint-modal-content u-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="create-sprint-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sprint-modal-header">
          <h3 className="sprint-modal-title" id="create-sprint-title">
            {isPlanning ? 'Crear sprint de planificación' : 'Crear nuevo sprint'}
          </h3>
          <button className="sprint-modal-close" onClick={onClose} aria-label="Cerrar">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="sprint-modal-body">
          <div className="sprint-form-group">
            <label className="sprint-form-label">Nombre del sprint *</label>
            <input
              type="text"
              className="sprint-form-input"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej: WEB.26_07.SEO-SP20 · Julio"
              required
              autoFocus
            />
          </div>

          <div className="sprint-form-row">
            <div className="sprint-form-group">
              <label className="sprint-form-label">Fecha de inicio</label>
              <input
                type="date"
                className="sprint-form-input"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
              />
            </div>

            <div className="sprint-form-group">
              <label className="sprint-form-label">Fecha de fin</label>
              <input
                type="date"
                className="sprint-form-input"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
              />
            </div>
          </div>

          <div className="sprint-modal-footer">
            <button type="button" className="sprint-btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button
              type="submit"
              className="sprint-btn-primary"
              disabled={submitting || !nombre.trim()}
            >
              <Save size={16} />
              {submitting ? 'Creando...' : (isPlanning ? 'Crear planificación' : 'Crear sprint')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateSprintModal;
